angular
.module('inkfinder')

.constant('ENDPOINT', {
  server: getServer()
})

.constant('APP', {
  facebook: getFacebookKey(),
  googleStatus: process.env.NODE_ENV === 'production' ? 'auto' : 'none'
})

.config(function($logProvider) {
  $logProvider.debugEnabled(true);
  if (process.env.NODE_ENV === 'prod') {
    $logProvider.debugEnabled(false);
  }
});

/**
 * @name getServer
 * @description Function to get the value of the server URL based on the
 * environment
 * @return {string} Returns the value of the server URL
 */
function getServer() {
  if (process.env.NODE_ENV === 'staging') {
    return 'https://staging-app.inkfinder.tattoo:8443/';
  }
  if (process.env.NODE_ENV === 'prod') {
    return 'https://inkfinder.tattoo:8100/';
  }
  if (process.env.NODE_ENV === 'dev') {
    return 'http://localhost:8300/';
  }
  return 'http://localhost:8300/';
}

/**
 * @name getFacebookKey
 * @description Function to get the Facebook key ID based on the environment
 * @return {string} Returns the Facebook key
 */
function getFacebookKey() {
  if (process.env.NODE_ENV === 'staging') {
    return '246422285698548';
  }
  if (process.env.NODE_ENV === 'prod') {
    return '237772826563494';
  }
  return '237777829896327';
}



// WEBPACK FOOTER //
// ./app.environment.js